import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISipLabel } from '@obvious.tech/constellation'

export const SipLabel = defineEntity('SipLabel', {
  endpoint: 'sip/api/SipLabel',
  schema: SNoop<ISipLabel>(),
})
